import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {LanguageService} from "../services/language.service";

export const languageGuard: CanActivateFn = async () => {
  const languageService = inject(LanguageService);
  return await languageService.init();
};
